export default "__VITE_ASSET__COA7V7UQ__"